import AgoraRTC from 'agora-rtc-sdk-ng';

export default {
  // configure Agora logs
  configureAgoraLogs() {
    if (process.env.VUE_APP_AGORA_ENABLE_UPLOAD == 'true') {
      AgoraRTC.enableLogUpload();
    }
    AgoraRTC.setLogLevel(4);
  }
}

